import { render, staticRenderFns } from "./LoaderButton.vue?vue&type=template&id=457fdaf2&scoped=true&"
import script from "./LoaderButton.vue?vue&type=script&lang=js&"
export * from "./LoaderButton.vue?vue&type=script&lang=js&"
import style0 from "./LoaderButton.vue?vue&type=style&index=0&id=457fdaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fdaf2",
  null
  
)

export default component.exports